module.exports = __webpack_public_path__ + "img/icon-warning.b6ccdaee.svg";